import get from 'lodash/get';
import pick from 'lodash/pick';
import Arg from '@spothero/arg';
import APIUtils from '@spothero/utils/api';
import SentryUtils from '@spothero/utils/sentry';
import CheckoutUtils from 'checkout/checkout-utils';
import SearchUtils from 'search/search-utils';

const SearchAPI = {
    /**
     * Sets a value in the selected storage type.
     * @static
     * @function cleanParams
     * @param {Object} data - The data to pass to the endpoint.
     * @example
     * SearchAPI.cleanParams({latitude: 41.8808377, longitude: -87.6242212, ...etc});
     * SearchAPI.cleanParams({url: 'https://spothero.com/san-jose-parking/60-delmas-ave?starts=2018-02-12T10%3A00%26ends=2018-02-12T13%3A00%26rid=3058'});
     * @returns {Object} The response data.
     */
    cleanParams(data) {
        const urlParams = Arg.parse(data.url);
        const adParams = pick(urlParams, [
            'gclid',
            'referrer',
            'sha_affiliate',
            'utm_source',
            'utm_medium',
            'utm_campaign',
            'utm_term',
            'utm_content',
        ]);

        return APIUtils.get('/search-params/', data)
            .then(response => {
                const responseData = response.data.data;
                const PageUtils =
                    responseData.page_info.page_type === 'checkout'
                        ? CheckoutUtils
                        : SearchUtils;

                // eslint-disable-next-line camelcase
                response.data.data.search_url = PageUtils.updateRoute({
                    currentUrl: responseData.search_url,
                    searchParams: responseData,
                    adParams,
                });

                return Promise.resolve(response);
            })
            .catch(error => {
                const errorMessage =
                    error &&
                    (error.message ||
                        error.statusText ||
                        get(error, 'response.data', ''));

                SentryUtils.addData({
                    caughtError: error,
                });
                SentryUtils.sendMessage({
                    message: errorMessage,
                    level: 'error',
                });

                return Promise.reject(new Error(error));
            });
    },

    getIdealSearchDistance({
        latitude,
        longitude,
        isMonthly = null,
        pageType = null,
    }) {
        return APIUtils.get('/ideal-search-distance/', {
            latitude,
            longitude,
            ...(isMonthly && {monthly: isMonthly}),
            // eslint-disable-next-line camelcase
            ...(pageType && {page_type: pageType}),
        }).then(({data: {data: {ideal_search_distance: distance}}}) =>
            parseFloat(distance)
        );
    },
};

export default SearchAPI;
